import React, { useState, useEffect } from "react" ;
import Form from 'react-bootstrap/Form'
import { getPostsByYear } from "root/DataFunctions/ChildDataFns";
import ChildPostDetailNew from "../Components/ChildPostDetailNew";
import PostCard from "../Components/UI/PostCard";
import Loading from "../Components/Loading";

const LifeStory = () => {
    const [lifeStories, setlifeStories] = useState("");
    const [dropDownYear, setDropDownYear] = useState("LAST 12 MONTHS");

    const [index, setIndex] = useState(null);
    const filteredPost = lifeStories.rows ? lifeStories.rows[index] : '';

    // Loop gallery array
    const checkNumber = (number) => {
        if(number > lifeStories.rows.length - 1) {
            return 0;
        }
        if (number < 0) {
            return lifeStories.rows.length - 1;
        }
        return number;
    }
    
    const onNextPost = () => {
        setIndex((index) => {
            let newIndex = index + 1;
            return checkNumber(newIndex);
        })
    }
    
    const onPrevPost = () => {
        setIndex((index) => {
            let newIndex = index - 1;
            return checkNumber(newIndex);
        })
    }

    const onSetIndexFromPost = (indx) => {
        setIndex(indx)
    }    

    useEffect(() => {
        getPostsByYear(dropDownYear, false, (response) =>
        {
            setlifeStories(response);
        });
    }, [dropDownYear]);
    return (
        <div style={{flex: "1"}}>
            <div className="child_breadcrumb child_breadcrumb-main">
                <div className="child_breadcrumb_inner">
                    <h2 className="child_breadcrumb_title">Life Story</h2>

                    <Form.Group controlId="formBasicSelect">
                        {/* <Form.Label>Select Norm Type</Form.Label> */}
                        <Form.Control
                            as="select"
                            value={dropDownYear}
                            onChange={e => {
                                setDropDownYear(e.target.value);
                              }}
                        >
                            {lifeStories.years && lifeStories.years.map((year) => {
                                return (
                                    <option key={year.year} value={year.year}>
                                        {year.year}
                                    </option>
                                )
                            })}
                            <option value="LAST 12 MONTHS">Last 12 Months</option>
                        </Form.Control>
                    </Form.Group>
                </div>
            </div>
            <div className="article-container article-container_lifestory">

                {lifeStories.rows 
                    && index !== null 
                    && <ChildPostDetailNew 
                    totalPost={lifeStories.rows.length} 
                    index={index} 
                    filteredPost={filteredPost} 
                    nextPost={onNextPost} 
                    prevPost={onPrevPost} 
                    setIndex={setIndex} 
                    />
                }

                {lifeStories.rows 
                    ? lifeStories.rows.map((lifeStory, i) =>
                        <PostCard key={lifeStory.post_id} lifeStory={lifeStory} setIndexFromPost={onSetIndexFromPost} postIndex={i}/>
                    ) 
                    : <Loading />
                }

            </div>
        </div>
    );
}

export default LifeStory;
